import { Component } from '@angular/core';
import { IzzyChannelActionEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Channel Actions') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-izzychannelaction-form',
    templateUrl: './izzychannelaction.form.component.html'
})
export class IzzyChannelActionFormComponent extends BaseFormComponent {
    public record!: IzzyChannelActionEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'identificationReferences', sectionName: 'Identification & References', isExpanded: true },
            { sectionKey: 'configurationExecution', sectionName: 'Configuration & Execution', isExpanded: true },
            { sectionKey: 'systemMetadata', sectionName: 'System Metadata', isExpanded: false }
        ]);
    }
}

